import { render, staticRenderFns } from "./DocumentTypeCommonFilters.vue?vue&type=template&id=6b481e6e&"
import script from "./DocumentTypeCommonFilters.vue?vue&type=script&lang=js&"
export * from "./DocumentTypeCommonFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports